module.exports = __webpack_public_path__ + "img/img-stepparley.538e7c62.png";